import { FlexRow } from '@/components/common/Flex';
import { Subheader } from '@/components/common/Typography';
import { FlexProps, Skeleton, SkeletonCircle } from '@chakra-ui/react';
import { PAGE_MODE_MINE_COLOR } from '@common/react/pageMode';
import { isSingleplayer, useCurrentUser } from '@common/react/user';
import GoalIcon from '../GoalIcon';
import { useGoalDetailContext } from './GoalDetailContext';

export default function GoalDetailHeaderLayout({
    children,
    ...props
}: FlexProps) {
    const currentUser = useCurrentUser();
    const { goalLoading, goal } = useGoalDetailContext();
    const isPrivate =
        goal?.shareStatus === 'PRIVATE' && !isSingleplayer(currentUser);
    const bg = isPrivate ? PAGE_MODE_MINE_COLOR : 'gray.50';

    const content =
        goalLoading || !goal ? (
            <>
                <FlexRow align="center" gap={3}>
                    <SkeletonCircle size="8" variant="darkGray" />
                    <Skeleton w={40} h={8} variant="darkGray" />
                </FlexRow>
                <SkeletonCircle size="8" variant="darkGray" />
            </>
        ) : (
            <>
                <FlexRow align="center" gap={3}>
                    <GoalIcon size="xl" inverted={isPrivate} goal={goal} />
                    <Subheader color={isPrivate ? 'white' : 'textDark'}>
                        {goal.name}
                    </Subheader>
                </FlexRow>
                <FlexRow align="center" gap={3}>
                    {children}
                </FlexRow>
            </>
        );

    return (
        <FlexRow
            {...props}
            py={{ base: 6, '2xl': 8 }}
            px={16}
            bg={bg}
            justify="space-between"
            align="center"
        >
            {content}
        </FlexRow>
    );
}
